import { registerLocaleData } from "@angular/common";
import LocaleFr from '@angular/common/locales/fr';
import { NgModule, Type } from "@angular/core";
import { FirstUpperCasePipe } from "./first-upper-case.pipe";
import { SsnPipe } from "./ssn.pipe";


const pipes: Type<any>[] = [
	FirstUpperCasePipe,
	SsnPipe
];

@NgModule({
	imports: [],
	exports: pipes,
	declarations: pipes,
	providers: pipes
})
export class PipeANAKINModule {
	constructor() {
		registerLocaleData(LocaleFr);
	}
}
